var _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgSpotlight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.3033C0 2.37437 2.37437 0 5.3033 0C6.70982 0 8.05874 0.558739 9.0533 1.5533L32 24.5H0V5.3033Z",
    fill: "url(#paint0_linear_5419_12656)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.47921 7.2085H10.5209V9.79183H9.47921V7.2085ZM12.962 10.7972L14.7885 8.97119L15.525 9.70765L13.6984 11.5342L12.962 10.7972ZM14.7084 13.9793H17.2917V15.021H14.7084V13.9793ZM12.9651 18.2001L13.7016 17.4636L15.5281 19.2902L14.7917 20.0261L12.9651 18.2001ZM9.47921 19.2084H10.5209V21.7917H9.47921V19.2084ZM4.47717 19.293L6.30426 17.4665L7.04071 18.2029L5.21415 20.0295L4.47717 19.293ZM2.70837 13.9793H5.29171V15.021H2.70837V13.9793ZM4.47402 9.71009L5.211 8.97363L7.03756 10.8002L6.3011 11.5367L4.47402 9.71009ZM10 12.4168C11.1506 12.4168 12.0834 13.3496 12.0834 14.5002C12.0834 15.6508 11.1506 16.5835 10 16.5835C8.84945 16.5835 7.91671 15.6508 7.91671 14.5002C7.91671 13.3496 8.84945 12.4168 10 12.4168ZM10 11.3752C8.27415 11.3752 6.87504 12.7743 6.87504 14.5002C6.87504 16.2261 8.27415 17.6252 10 17.6252C11.7259 17.6252 13.125 16.2261 13.125 14.5002C13.125 12.7743 11.7259 11.3752 10 11.3752Z",
    fill: "#161616"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5419_12656",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1AA56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1AA56",
    stopOpacity: 0
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgSpotlight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/spotlight.38d34ab0ae40938fa784e35276943ffa.svg";